enum CampaignPhase {
  Finished = 'Finished',
  InProgress = 'InProgress',
  Next = 'Next',
}

export default CampaignPhase;
